import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, fromEvent, map, of, switchMap, tap } from 'rxjs';
import { CaseInteractionService } from 'src/app/cases/case-interaction.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatToolbar } from '@angular/material/toolbar';
import { LoginComponent } from '../../login/login.component';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-page-wrapper',
    templateUrl: './page-wrapper.component.html',
    styleUrls: ['./page-wrapper.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, MatToolbar, LoginComponent, MatButton, MatTooltip, AsyncPipe]
})
export class PageWrapperComponent {
	private readonly _interractionService = inject(CaseInteractionService);
	private readonly _navigationService = inject(NavigationService);


	currentYear = new Date().getFullYear();
	isAuthenticated: boolean = false;
	backgroundImageUrl$ = new Observable<string | null>();
	disableBackgroundImage: boolean = true;
	
	constructor()
	{
		this.backgroundImageUrl$ = this._interractionService.caseReceived$.pipe(
			untilDestroyed(this),
			tap((v) => {
				window.scrollTo(0, 0);
			}),
			switchMap((v) => {
				if (v.backgroundImageUrl) {
					let img = new Image();
					img.src = v.backgroundImageUrl;	
					return fromEvent(img, 'load').pipe(map((e => (e.target as HTMLImageElement).src)));
				}				
				return of(null);
			}),
			map(v => {
				if (v) {
					return `--backgroundImageUrl: url(${v})`;	
				}
				else {
					return null;
				}
			})
		);

		this._navigationService.navigationEnd$
			.pipe(
				untilDestroyed(this)
			)
			.subscribe(nav => {
				if (!nav.url.includes('/stories')) {
					this.disableBackgroundImage = true;
				}
				else {
					this.disableBackgroundImage = false;
				}
			});
	}
}